var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "117px",
    height: "18px",
    viewBox: "0 0 117 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-8.4%",
    y: "-210.2%",
    width: "116.7%",
    height: "520.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-o0km1wxdr5-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send-Notifications",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Send-Notification-1",
    transform: "translate(-920.000000, -699.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(200.000000, 126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(491.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(61.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image-Drop-Copy-3",
    transform: "translate(0.000000, 336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(147.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(15.372536, 26.103393)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    filter: "url(#filter-o0km1wxdr5-1)",
    cx: 54.190819,
    cy: 80.9278571,
    rx: 53.8862916,
    ry: 2.140625
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadow);
export default __webpack_public_path__ + "static/media/shadow.e21d565cb326a208a5d2ee890b95c5f5.svg";
export { ForwardRef as ReactComponent };